module.exports = __webpack_public_path__ + "static/img/bundles__img-3.8a44fbce.svg";